import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { ApiService } from '@services/api.service';
import { Usuario } from '../models/usuario';
import { Papel } from '../models/papel';
import { Permissao } from '../models/permissao';

@Injectable({
  providedIn: 'root'
})
export class GerenciarPerfisUsuariosApiService extends ApiService {

  private readonly baseUrlRoute = 'gerenciar-perfis-usuarios';

  constructor(
    public override http: HttpClient,
  ) {
    super(http);
  }

  public listarUsuarios(): Observable<Usuario[]> {
    return this.get<Usuario[]>(`/${this.baseUrlRoute}`);
  }

  public listarPapeis(): Observable<Papel[]> {
    return this.get<Papel[]>(`/${this.baseUrlRoute}/papeis`);
  }

  public listarPermissoes(): Observable<Permissao[]> {
    return this.get<Permissao[]>(`/${this.baseUrlRoute}/permissoes`);
  }

  public criarPapel(nome: string, descricao: string): Observable<Papel> {
    return this.post<Papel>(`/${this.baseUrlRoute}/papeis`, null, { nome, descricao });
  }

  public editarPapeisUsuario(usuarioId: number, papelIds: number[]): Observable<void> {
    return this.patch<void>(`/${this.baseUrlRoute}/${usuarioId}/papeis`, undefined, { papelIds });
  }

  public editarPermissoesPapel(papelId: number, permissaoIds: number[]): Observable<void> {
    return this.patch<void>(`/${this.baseUrlRoute}/papeis/${papelId}/permissoes`, undefined, { permissaoIds });
  }

  public aprovarUsuario(usuarioId: number): Observable<void> {
    return this.patch<void>(`/${this.baseUrlRoute}/aprovar/${usuarioId}`);
  }

  public rejeitarUsuario(usuarioId: number): Observable<void> {
    return this.delete<void>(`/${this.baseUrlRoute}/rejeitar/${usuarioId}`);
  }

  public trocarSenhaUsuario(usuarioId: number, novaSenha: string): Observable<void> {
    return this.patch<void>(`/${this.baseUrlRoute}/trocar-senha/${usuarioId}`, undefined, { novaSenha });
  }
}
